/**
 * statusLabel — the ONE way a stored status value becomes words on screen.
 *
 * Stored statuses keep their database spelling (`cancelled`, `pending_payment`,
 * `no_show`); those are an API and do not change. What staff and families read
 * is US English: "Canceled", "Pending payment", "No show". Capitalizing the
 * stored value in place (`status.charAt(0).toUpperCase() + status.slice(1)`)
 * showed the British "Cancelled" on badges and filters, and left underscores
 * in multi-word statuses.
 *
 * Use this for every badge, filter button or table cell that shows a stored
 * status. Unknown values fall back to "first letter capitalized, underscores
 * as spaces", so a new status still reads sensibly.
 */

const STATUS_LABELS: Record<string, string> = {
  cancelled: "Canceled",
  canceled: "Canceled",
  cancelling: "Canceling",
  canceling: "Canceling",
  pending_payment: "Pending payment",
  partially_paid: "Partially paid",
  partially_refunded: "Partially refunded",
  no_show: "No show",
  in_progress: "In progress",
  checked_in: "Checked in",
};

export function statusLabel(status: string | null | undefined): string {
  if (!status) return "";
  const key = String(status).trim();
  const known = STATUS_LABELS[key.toLowerCase()];
  if (known) return known;
  const spaced = key.replace(/_/g, " ");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
